import $ from 'jquery';
import '../vendor/jquery.event.move';
import twentytwenty from '../vendor/jquery.twentytwenty';
import imagesLoaded from 'imagesloaded';


/* Global variables
********************************************/



/* Comparison Slider
********************************************/

$( '.js-juxtapose' ).imagesLoaded( function() {
	$( '.js-juxtapose' ).twentytwenty();
} );
